import { render, staticRenderFns } from "./search_ads.vue?vue&type=template&id=55d2f1b4"
import script from "./search_ads.vue?vue&type=script&lang=js"
export * from "./search_ads.vue?vue&type=script&lang=js"
import style0 from "./search_ads.vue?vue&type=style&index=0&id=55d2f1b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports